import React from 'react';
import { makeStyles, TextField as MuiTextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  notchedOutline: {
    border: 'none !important',
  }
}));

const ChipAutocomplete = ({
  options,
  value,
  onChange,
  getOptionLabel,
  label,
  placeholder,
  error,
  noBorder,
  helperText,
  ...props
}: any) => {
  const classes = useStyles();
  // todo
  // filter out selected options
  // accept ids as value
  // send ids as onchange value
  let renderInput;

  if (noBorder) {
    renderInput = (params: any) => (
      <MuiTextField
        {...params}
        InputProps={{
          ...params.InputProps,
          classes: {
            ...params.InputProps.classes,
            notchedOutline: classes.notchedOutline
          }
        }}
        variant="outlined"
        fullWidth
      />
    );
  } else {
    renderInput = (params: any) => (
      <MuiTextField
        {...params}
        label={label}
        placeholder={placeholder}
        error={error}
        variant="outlined"
      />
    );
  }

  return (
    <Autocomplete
      options={options}
      value={value}
      onChange={onChange}
      getOptionLabel={getOptionLabel}
      multiple
      fullWidth
      renderInput={renderInput}
      {...props}
    />
  );
};

export default ChipAutocomplete;
